import React from 'react';
import {useTranslation} from 'react-i18next';

import {ETextInput} from '@ELib/components/form/ETextInput';

import {GroupWrapper} from '../sharedStyles/login';

import {SubviewProps} from './types';

export const UsernameStep = ({
  form,
  setForm,
}: SubviewProps): React.ReactElement => {
  const {t} = useTranslation('lib');

  const setUsername = (username: string) => setForm({...form, username});

  return (
    <>
      <GroupWrapper>
        <ETextInput
          label={t('login.inputs.username')}
          value={form.username}
          onChange={(event) => setUsername(event.target.value)}
        />
      </GroupWrapper>
    </>
  );
};
